import { MoneySchema } from "@redotech/money";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export enum MercurySummaryAnalyticsInputKind {
  ALL = "ALL",
  BY_CHECKOUT_EXPERIENCE_ID = "BY_CHECKOUT_EXPERIENCE_ID",
}

export const getMercurySummaryAnalytics = {
  name: "getMercurySummaryAnalytics" as const,
  input: z.union([
    z.object({ kind: z.literal(MercurySummaryAnalyticsInputKind.ALL) }),
    z.object({
      kind: z.literal(
        MercurySummaryAnalyticsInputKind.BY_CHECKOUT_EXPERIENCE_ID,
      ),
      checkoutExperienceId: zExt.objectId(),
    }),
  ]),
  output: z.object({
    totalRevenueCapturedShopMoney: MoneySchema,
    priceCombinationsTested: z.number(),
    priceCombinationsExplored: z.number(),
  }),
};
